import { render, staticRenderFns } from "./HeaderNotification.vue?vue&type=template&id=a12563ec&scoped=true"
import script from "./HeaderNotification.vue?vue&type=script&lang=js"
export * from "./HeaderNotification.vue?vue&type=script&lang=js"
import style0 from "./HeaderNotification.scss?vue&type=style&index=0&id=a12563ec&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12563ec",
  null
  
)

export default component.exports